"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const lucide_vue_next_1 = require("lucide-vue-next");
const exception2alert_1 = require("@common/tsutils/exception2alert");
let ClusterEditorSave = class ClusterEditorSave extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.savedStatus = '-';
        this.saved_cluster_name = '';
        this.saved_cluster_shared = false;
        this.error_msg = '';
    }
    backToSave() {
        this.savedStatus = '-';
    }
    resetStatus() {
        this.savedStatus = '-';
    }
    async saveCuster() {
        this.error_msg = '';
        try {
            await this.saved_cluster_list.save(this.clusters, this.saved_cluster_name, this.saved_cluster_shared);
            this.savedStatus = 'ok';
            this.clusters.name = this.saved_cluster_name;
            this.reset();
        }
        catch (e) {
            this.error_msg = (0, exception2alert_1.exception2string)(e);
            this.savedStatus = 'err';
        }
    }
    reset() {
        this.saved_cluster_name = '';
        this.saved_cluster_shared = false;
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], ClusterEditorSave.prototype, "clusters", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], ClusterEditorSave.prototype, "saved_cluster_list", void 0);
ClusterEditorSave = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            Save: lucide_vue_next_1.Save,
        }
    })
], ClusterEditorSave);
exports.default = ClusterEditorSave;
